import { render } from "./grupoopciones.vue?vue&type=template&id=56cc6610&scoped=true"
import script from "./grupoopciones.vue?vue&type=script&lang=js"
export * from "./grupoopciones.vue?vue&type=script&lang=js"

import "./grupoopciones.vue?vue&type=style&index=0&id=56cc6610&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cc6610"]])

export default __exports__